import { useEntity } from '@backstage/plugin-catalog-react';
import { MissingAnnotationEmptyState } from '@backstage/core-components';
import { WorkflowList } from '../WorkflowList';
import {
  ARGO_LABEL_SELECTOR_ANNOTATION,
  readArgoBinding,
} from '../../api/labelSelector';

export function EntityArgoWorkflowsCard() {
  const { entity } = useEntity();
  const binding = readArgoBinding(entity);

  if (!binding) {
    return (
      <MissingAnnotationEmptyState annotation={ARGO_LABEL_SELECTOR_ANNOTATION} />
    );
  }

  return (
    <WorkflowList namespace={binding.namespace} labelSelector={binding.labelSelector} />
  );
}
